import {ProductSelectionGroup, ProductSelectionOption} from "@/data/entities/cart";
import React from "react";
import {Badge} from "peggirkit";
import {FormattedMessage} from "react-intl";

type Props = {
    displayName: string,
    group: ProductSelectionGroup,
    notifyMaxReached: boolean,
    selectedValues: ProductSelectionOption[],
};

const ProductOptionListHeader = ({displayName, group, notifyMaxReached, selectedValues}: Props) => {
    return (
        <header
            className={"sticky top-0 bg-white dark:bg-slate-800 w-full border-b border-b-gray-200 dark:border-b-slate-700 px-4 py-3 font-medium text-xs text-gray-600 dark:text-slate-100 flex flex-row items-end justify-between gap-3"}
        >
            <span className={"whitespace-nowrap truncate"}>
                {displayName}
            </span>

            {
                (group.canSelectMultiple && group.maxOptions > 0) &&
                <Badge
                    size={"xs"}
                    containerClassname={notifyMaxReached ? "animate-wiggle" : ""}
                    color={
                        selectedValues.length === group.maxOptions
                            ? "danger"
                            : "secondary"
                    }
                >
                    <FormattedMessage
                        id={"n-of-total"}
                        values={{
                            n: selectedValues.length,
                            total: group.maxOptions,
                        }}
                    />
                </Badge>
            }
        </header>
    );
};

export default ProductOptionListHeader;